import { useForm } from '@/common/form/FormContext';
import { TextFormField } from '@/common/form/formFields/TextFormField';
import { ProgPriceFormulaValue } from './value/formula/ProgPriceFormulaValue';
import { TextField } from '@mui/material';

export const ProgPriceValue = ({ fieldDef }) => {
  const { formValues } = useForm();
  const calcType = formValues.progPriceCalcType;

  const renderers = {
    FORMULA: ProgPriceFormulaValue,
    // TODO:
    // FLAT:   FlatValue,
    // PERCENT: PercentValue,
    // …etc…
  };

  // If no calculation type is selected, we render form field as text without edit ability
  if (!calcType) return <TextField label={fieldDef.displayName} disabled={true}/>;; 

  // if calcType is undefined (or not in your map), fall back to TextFormField
  const FieldComponent = renderers[calcType] || TextFormField;

  return (
    <FieldComponent
      key={calcType ?? 'default'}
      fieldDef={fieldDef}
    />
  );
};
